<template>
	<v-container fluid>
		<v-layout row wrap>
			<v-flex xs12>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.reportsContacts')}}</b></span><br><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md3 xs12 offset-md1>
				<InputField
					v-model="email"
					:label="$t('fields.email')"
					@keyup.native.enter="search"></InputField>
				<InputField
					v-model="phoneNo"
					:label="$t('fields.phoneNo')"
					@keyup.native.enter="search"></InputField>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex md10 xs12 offset-md1>
				<v-btn color="grey lighten-1" @click="search">
					{{ $t('buttons.search') }}
				</v-btn>
			</v-flex>
			<v-flex md1 xs12 text-md-right text-xs-right>
				<v-tooltip bottom>
				<v-btn @click="excelExport" icon slot="activator">
					<v-icon small>fa-file-excel</v-icon>
				</v-btn>
				<span>{{$t('tooltips.excel')}}</span>
			</v-tooltip>
			</v-flex>
		</v-layout>
		<v-layout row wrap pt-3>
			<v-flex xs12>
				<DataTableContacts
						:excel="false"
						:filter="false"
						:headers="contactsTable.headers"
						:items="contactsTable.items"
						:total="contactsTable.total"
						@reload="reloadData"
						@excel="excelExport"
					>
						<template #row="props">
							<tr :class="{'cursor-pointer': true}" @contextmenu.prevent="editClick(props.item.id, true)">
								<td @click="editClick(props.item.link, false)">{{ props.item.type }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.name }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.email }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.telephoneNo }}</td>
								<td @click="editClick(props.item.link, false)">{{ props.item.mobilePhoneNo }}</td>
							</tr>
						</template>
					</DataTableContacts>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import DataTableContacts from "./trinkets/DataTableContacts";
import InputField from "./trinkets/InputField";

export default {
	name: "ReportsContacts",
	components: {DataTableContacts, InputField},
	data: function () {
		return {
			contactsTable: {
				headers: [
					{text: this.$t('fields.type'), value: 'type', type: 'string', searchable: false},
					{text: this.$t('fields.name'), value: 'name', type: 'string', searchable: false},
					{text: this.$t('fields.email'), value: 'email', type: 'string', searchable: false},
					{text: this.$t('fields.telephoneNo'), value: 'telephoneNo', type: 'string', searchable: false},
					{text: this.$t('fields.mobilePhoneNo'), value: 'mobilePhoneNo', type: 'string', searchable: false}
				],
				items: [],
				total: 0,
				lastRequest: null
			},
			email: '',
			phoneNo: ''
		}
	},
	methods: {
		reloadData(request) {
			this.lastRequest = request;
			let vm = this;
			this.$APICall('get', 'report-contacts', request, (data, success) => {
				if (success) {
					vm.contactsTable.items = data.items;
					vm.contactsTable.total = data.total;
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		},
		excelExport() {
			if(this.contactsTable.items != undefined && this.contactsTable.items != null){
				if(this.contactsTable.items.length != 0){
					this.$APICall('post', 'excel/report-contacts', this.contactsTable.items, (data, success) => {
						window.open(data.link);
					});
				}
			}
		},
		search(){
			this.email = this.email.trim();
			this.phoneNo = this.phoneNo.trim();
			let data = {
				email: this.email,
				phone: this.phoneNo
			}
			this.reloadData(data);
		},
		editClick(link){
			window.open(link);
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.reports'), href: '/#/reports', disabled: true}
		]);
	}
}
</script>

<style scoped>

</style>
